"use client";

import { useEffect, useState } from "react";

const WORDS = ["Clarity.", "Control.", "Confidence.", "Safety.", "Speed."];
const INTERVAL = 2800;
const FADE_DURATION = 500;

export function AnimatedHeroText() {
  const [index, setIndex] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setIndex((i) => (i + 1) % WORDS.length);
        setFading(false);
      }, FADE_DURATION);
    }, INTERVAL);
    return () => clearInterval(timer);
  }, []);

  return (
    <span
      className="inline-block text-primary transition-all"
      style={{
        opacity: fading ? 0 : 1,
        transform: fading ? "translateY(8px)" : "translateY(0)",
        transition: `opacity ${FADE_DURATION}ms ease, transform ${FADE_DURATION}ms ease`,
        minWidth: "5ch",
      }}
    >
      {WORDS[index]}
    </span>
  );
}
